// Product page "Write a review" form. Posts to Judge.me's public review endpoint
// (POST https://api.judge.me/api/v1/reviews, no auth), the same one Judge.me's own
// widget form uses. Sent as a simple form-encoded request so no CORS preflight is needed.
const ENDPOINT = 'https://api.judge.me/api/v1/reviews';

class SWriteReview extends HTMLElement {
  connectedCallback() {
    this.openButton = this.querySelector('[data-open]');
    this.form = this.querySelector('[data-form]');
    this.error = this.querySelector('[data-error]');
    this.thanks = this.querySelector('[data-thanks]');
    this.openButton?.addEventListener('click', () => this.toggle());
    this.form?.addEventListener('submit', (event) => this.submit(event));
  }

  toggle() {
    const open = this.form.hidden;
    this.form.hidden = !open;
    this.openButton.setAttribute('aria-expanded', String(open));
    if (open) this.form.querySelector('input')?.focus();
  }

  async submit(event) {
    event.preventDefault();
    const data = new FormData(this.form);
    const valid = this.form.checkValidity() && data.get('rating');
    if (!valid) {
      this.error.hidden = false;
      this.form.reportValidity();
      return;
    }
    this.error.hidden = true;
    const submitButton = this.form.querySelector('[type="submit"]');
    submitButton.disabled = true;

    const body = new URLSearchParams({
      shop_domain: this.dataset.shop,
      platform: 'shopify',
      id: this.dataset.productId,
      name: String(data.get('name')).trim(),
      email: String(data.get('email')).trim(),
      rating: String(data.get('rating')),
      title: String(data.get('title') || '').trim(),
      body: String(data.get('body')).trim(),
    });

    try {
      // no-cors: Judge.me accepts the review either way; the response is not readable cross-origin.
      await fetch(ENDPOINT, { method: 'POST', mode: 'no-cors', body });
      this.form.hidden = true;
      this.openButton.hidden = true;
      this.thanks.hidden = false;
      this.thanks.focus?.();
    } catch {
      this.error.hidden = false;
      submitButton.disabled = false;
    }
  }
}

if (!customElements.get('s-write-review')) customElements.define('s-write-review', SWriteReview);
